const TYPE = "pedido";
const moment = require("moment");

const pedidoModule = {
  findAll: async (dbConnection, periodo) => {
    let pedidos = [];
    let dataInicial = moment().startOf("day").utc();
    let dataFinal = moment().endOf("day").utc();

    if (periodo === "ontem") {
      dataInicial = dataInicial.subtract(1, "days");
      dataFinal = dataFinal.subtract(1, "days");
    }

    dataInicial = dataInicial.format("YYYY-MM-DD HH:mm:ss");
    dataFinal = dataFinal.format("YYYY-MM-DD HH:mm:ss");

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        data: {
          $gte: dataInicial,
          $lte: dataFinal,
        },
      },
      limit: 50000,
    });

    if (result.docs.length) {
      pedidos = result.docs;

      pedidos = pedidos.map((item) => {
        item.newDate = new Date(item.data);
        return item;
      });

      pedidos = pedidos.sort(function (a, b) {
        return b.newDate.getTime() - a.newDate.getTime();
      });
    }

    return pedidos;
  },
  findById: async (dbConnection, idPedido, fields = null) => {
    let pedido = null;
    let query = {
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: idPedido },
      },
      limit: 1,
    };

    if (fields !== null) {
      query.fields = fields;
    }

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      pedido = result.docs[0];
    }

    return pedido;
  },
  findById2: async (dbConnection, idPedido) => {
    let pedido = null;

    let result = await dbConnection.find({
      selector: {
        type: { $eq: "orcamento" },
        _id: { $eq: idPedido },
      },
      // fields: ['_id', 'cliente.desc', 'condPagto.desc', 'formaPagto.desc', 'transportadora.desc', 'itens', 'observacao', 'valorTotal', 'codigo', 'enderecoEntrega', 'situacao', 'tipoPedido.desc', 'data', 'previsaoEntrega']
    });

    if (result.docs.length) {
      pedido = result.docs[0];
      let lista = [];
      lista.push(pedido);
      lista = getExpiracao(lista);
      pedido = lista[0];
    }

    return pedido;
  },
  findAllByPeriodo: async (dbConnection, dataInicial, dataFinal) => {
    let pedidos = [];
    dataInicial = moment(dataInicial).startOf("day").utc();
    dataFinal = moment(dataFinal).endOf("day").utc();

    dataInicial = dataInicial.format("YYYY-MM-DD HH:mm:ss");
    dataFinal = dataFinal.format("YYYY-MM-DD HH:mm:ss");

    let result = await dbConnection.find({
      selector: {
        $or: [
          {
            type: "pedido",
          },
          {
            type: "orcamento",
          },
        ],
        // data: {
        //   $gte: dataInicial,
        //   $lte: dataFinal,
        // },
        status: { $ne: "C" },
      },
      limit: 50000,
    });

    if (result.docs.length) {
      pedidos = result.docs;
      pedidos = getExpiracao(pedidos);
    }

    pedidos = pedidos.map((item) => {
      item.newDate = new Date(item.data);
      return item;
    });

    pedidos = pedidos.sort(function (a, b) {
      return b.newDate.getTime() - a.newDate.getTime();
    });

    return pedidos;
  },

  salvarPedido: async (
    dbConnection,
    novoPedido

  ) => {
    return new Promise(async (resolve, reject) => {
      const adicionarCoordenadas = async (coordenadas) => {
        novoPedido.coordenadas = coordenadas
        await dbConnection.put(novoPedido);
      }
      if ((await "geolocation") in navigator) {
        await navigator.geolocation.getCurrentPosition(
          async function (position) {
            await adicionarCoordenadas(
              `${position.coords.latitude},${position.coords.longitude}`
            );
            resolve();
          },
          async function (error) {
            console.log(error);
            await adicionarCoordenadas(null);
            resolve();
          }
        );
      } else {
        await adicionarCoordenadas(null);
        resolve();
      }
    });
  },

  getValorTotal: async (dbConnection) => {
    let pedidos = [];
    let valorTotal = 0;
    let dataInicial = moment()
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    let dataFinal = moment().endOf("day").utc().format("YYYY-MM-DD HH:mm:ss");

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        data: {
          $gte: dataInicial,
          $lte: dataFinal,
        },
      },
      limit: 50000,
      fields: ["valorTotal"],
    });

    if (result.docs.length) {
      pedidos = result.docs;

      for (let item of pedidos) {
        valorTotal += item.valorTotal;
      }
    }

    return valorTotal;
  },

  atualizarUrlPdf: async (dbConnection, idPedido, urlPdf) => {
    let pedido = null;

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: idPedido },
      },
      limit: 1,
    });

    if (result.docs.length) {
      pedido = result.docs[0];
    }

    if (pedido !== null) {
      pedido.emailEnviado = true;
      pedido.urlPdf = urlPdf;
      await dbConnection.post(pedido);
    }
  },

  atualizaSincOver: async (dbConnection, idPedido) => {
    let pedido = null;
    let query = {
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: idPedido },
      },
      limit: 1,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      pedido = result.docs[0];
      pedido.sincOver = true;
      await dbConnection.put(pedido);
    }
  },

  buscarPedidosSincronizarOver: async (dbConnection) => {
    let pedidos = [];

    let query = {
      selector: {
        type: "pedido",
        sinc: true,
        sincIntegracao: true,
        sincOver: {
          $eq: false,
        },
      },
      fields: ["_id"],
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      pedidos = result.docs;
    }

    return pedidos;
  },

};

const getExpiracao = (pedidos) => {
  for (let item of pedidos) {
    let permitidoAlteracao = true;
    let expiracao = {
      cor: "vermelho",
      texto: "Expira hoje",
    };
    let dataExpiracao = moment(item.data.toString().split("T")[0]).add(
      5,
      "days"
    );

    let duration = moment.duration(
      dataExpiracao.diff(moment().format("YYYY-MM-DD"))
    );
    let diferenca = parseInt(duration.asDays());

    if (item.status === "I" || diferenca < 0) {
      expiracao = {
        cor: "cinza",
        texto: "Expirado",
      };
      permitidoAlteracao = false;
    } else {
      if (diferenca === 0) {
        expiracao = {
          cor: "vermelho",
          texto: "Expira hoje",
        };
      }

      if (diferenca === 1) {
        expiracao = {
          cor: "laranja",
          texto: "Expira amanhã",
        };
      }
      if (diferenca > 1) {
        expiracao = {
          cor: "verde",
          texto: `Expira em ${diferenca} dias`,
        };
      }
    }
    expiracao.permitidoAlteracao = permitidoAlteracao;
    item.expiracao = expiracao;
  }
  return pedidos;
};

export default pedidoModule;
